import {ChangeDetectorRef, Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

/**
 * We replace the ngx-translate default pipe here because we need some special fallbacks.
 *
 * Fallbacks that are possible:
 *   - "textkey|extension | translate" => checks first for "textkey|extension" than "textkey"
 *   - "textkey | translate: {fallback: textkeydefault}" => checks first for "textkey" than "textkeydefault"
 *   - "textkey|extension | translate: {fallback: textkeydefault}" => checks first for "textkey|extension" than "textkey" than "textkeydefault"
 *   - "textkey|extension | translate: {fallback: textkeydefault|extension2}" => checks first for "textkey|extension" than "textkey" than "textkeydefault|extension2" than "textkeydefault"
 */
@Pipe({ name: 'translate', pure: false})
export class AppTranslatePipe implements PipeTransform  {

  /**
   * Holds the result of the requests.
   */
  value: string = "";

  /**
   * constructor for service injections
   * @param translate
   * @param _ref
   */
  constructor(private translate: TranslateService, private _ref: ChangeDetectorRef) {}

  /**
   * transaforms the input with the help of the TranslationServie by ngx-translate
   * @param textkey
   * @param args
   */
  transform(textkey, ...args: any[]) {
    if(textkey === null) {
      return null;
    }


    // 0. build list of possible textkeys
    let textKeys = [textkey];

    // 1. check for postfix
    const keyPostfix = textkey.match(/\|[a-z_]+$/);
    if(keyPostfix) {
      // build the new key
      textKeys.push(textkey.substr(0, textkey.length - (keyPostfix[0].length)));
    }

    // 2. check for fallback
    if (args && args.length > 0 && args[0]?.hasOwnProperty("fallback")) {
      // build the new key and remove th falback to avoid circular calls
      textKeys.push(args[0]["fallback"]);

      // 3. check for postfix in fallback
      const fallbackPostfix = args[0]["fallback"].match(/\|[a-z]+$/);
      if(fallbackPostfix) {
        // build the new key
        textKeys.push(args[0]["fallback"].substr(0, args[0]["fallback"].length - (fallbackPostfix[0].length)));
      }
    }

    // get all transaltion for all possible keys and chhose the last one in the list that was found
    this.translate.get(textKeys, args.length > 0? args[0] : null).subscribe(data => {
      let found = false;
      for(let i=0; i<textKeys.length; i++) {
        if(data[textKeys[i]] !== textKeys[i]) {
          found = true;
          this.value = data[textKeys[i]];
          break;
        }
      }
      if(found === false) {
        // fallback: show textkey if nothing was found
        this.value = textkey;
      }

      // mark content for change detection
      this._ref.markForCheck();
    });

    return this.value;
  }
}
